export default __webpack_public_path__ + "static/media/kabe_renzoku_thumb.dfb79882.png";